<template>
  <transition name="view" appear>
    <div>
      <HomeCustomDashboard />
    </div>
  </transition>
</template>
<script>
import HomeGraphs from '@/components/Home/HomeGraphs.vue';
import { TEMPLATE_HOME } from '@/utils/constants';

import { mapMutations, mapGetters } from 'vuex';
import HomeCustomDashboard from '../../components/Home/HomeCustomDashboard.vue';

export default {
  components: { HomeGraphs, HomeCustomDashboard },
  name: 'Home',
  computed: {
    ...mapGetters('globalState/settings', [
      'getDurationTime',
      'timezoneoffset',
    ]),
    ...mapGetters('browserState/browserCommonState', ['getAllBrowserServices']),
  },
  methods: {
    ...mapMutations('globalState/app', ['toggleMenu', 'setTemplate']),
  },
  mounted() {
    this.setTemplate(TEMPLATE_HOME);
  },
};
</script>
<style lang="scss" scoped></style>
